import { NavLink } from "react-router-dom";
import { useState } from "react";

export default function SectionServices({ _data }) {
  const [showModal, setShowModal] = useState(false);
  const [dataModal, setDataModal] = useState({});

  const handleOpenModal = (data) => {
    console.log(data);

    setDataModal(data);
    setShowModal(true);
  };
  const handleCloseModal = () => setShowModal(false);

  return (
    <>
      <div className="section-full p-t120 p-b90 site-bg-gray tw-service-gallery-style3-area">
        <div className="services-gallery-block-outer3">
          <div className="container">
            {/* TITLE START*/}
            <div className="section-head center wt-small-separator-outer">
              <div className="wt-small-separator site-text-primary">
                <div>{_data.title}</div>
              </div>
              <h3 className="wt-title">{_data.subtitle}</h3>
              <p className="section-head-text">{_data.description}</p>
            </div>
            {/* TITLE END*/}
            <div className="section-content">
              <div className="services-gallery-style3">
                <div className="row">
                  {_data.feats.map((_object, index) => (
                    <div key={index} className="col-lg-4 col-md-6 mb-4">
                      <div className="service-box-style3">
                        <div className="service-content">
                          <h3 className="service-title-large">
                            <span className="service-title-large-number">
                              {_object.serial}
                            </span>
                            <p>
                              {_object.title}
                            </p>
                          </h3>
                          <p>{_object.summary}</p>
                          <NavLink
                            to="#"
                            className="site-button-2"
                            onClick={() => handleOpenModal(_object)}
                          >
                            {_data.viewDetail}
                          </NavLink>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            {/* MODAL */}
            {showModal && (
              <div
                className="modal-backdrop"
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100vw",
                  height: "100vh",
                  background: "rgba(0,0,0,0.5)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 9999,
                }}
              >
                <div
                  className="modal-content"
                  style={{
                    background: "#fff",
                    padding: "2rem",
                    borderRadius: "8px",
                    maxWidth: "700px",
                    width: "90%",
                    maxHeight: "90vh",
                    overflowY: "auto",
                    WebkitOverflowScrolling: "touch",
                    position: "relative",
                  }}
                >
                  <button
                    onClick={handleCloseModal}
                    style={{
                      position: "absolute",
                      top: "10px",
                      right: "10px",
                      background: "none",
                      border: "none",
                      fontSize: "1.5rem",
                    }}
                  >
                    &times;
                  </button>
                  {/* Aquí va la información adicional */}
                  <h3>{dataModal.title}</h3>
                  {dataModal.details && (
                    <>
                      <div className="modal-body">
                        <p className="text-muted">{dataModal.details}</p>
                        <div className="row">
                          <div className="col-12 col-md-7">
                            <div className="row px-3">
                              <strong>{_data.deliverables}:</strong>
                              <ul className="ms-3 list-group list-group-flush">
                                {Array.isArray(dataModal.deliverables) &&
                                  dataModal.deliverables.map((item, idx) => (
                                    <li key={idx} className="list-group-item">
                                      {item}
                                    </li>
                                  ))}
                              </ul>
                              <hr className="ms-3" />
                            </div>
                            <div className="row px-3">
                              <strong>{_data.reqDocuments}:</strong>
                              <ul className="ms-3 list-group list-group-flush">
                                {Array.isArray(dataModal.requiredDocs) &&
                                  dataModal.requiredDocs.map((item, idx) => (
                                    <li key={idx} className="list-group-item">
                                      {item}
                                    </li>
                                  ))}
                              </ul>
                              <hr className="ms-3" />
                            </div>
                          </div>
                         <div className="d-none d-md-flex col-md-5 align-items-center justify-content-center">
                            <img
                              src={dataModal.image}
                              alt={dataModal.title}
                              style={{
                                maxWidth: "100%",
                                height: "auto",
                                boxShadow: "0 2px 12px rgba(0,0,0,0.25)",
                                borderRadius: "8px"
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
